import { OrderRoutes } from '../orders-routes.enum';
import { FlowDefinition } from './flow.types';

export const VOICE_FLOW: FlowDefinition = [
    {
        route: OrderRoutes.VOICE_PACKAGE_SELECTION,
        next: OrderRoutes.VOICE_CONFIGURATION,
        back: OrderRoutes.BUNDLE_HOMEPAGE
    },
    {
        route: OrderRoutes.VOICE_CONFIGURATION,
        next: (ctx, data) => data?.hasIncludedVoiceOffers
            ? OrderRoutes.ADDITIONAL_VOICE_OFFERS
            : OrderRoutes.PRODUCT_SUMMARY,
        back: OrderRoutes.VOICE_PACKAGE_SELECTION
    },
    {
        route: OrderRoutes.ADDITIONAL_VOICE_OFFERS,
        next: OrderRoutes.PRODUCT_SUMMARY,
        back: OrderRoutes.VOICE_CONFIGURATION
    },
    {
        route: OrderRoutes.CUSTOMER_ACCOUNT_SETUP,
        next: OrderRoutes.PRODUCT_SUMMARY,
        back: ctx => ctx.allowShippingAddressChange()
            ? OrderRoutes.ALTERNATE_SHIPPING
            : OrderRoutes.VOICE_CONFIGURATION
    },
    {
        route: OrderRoutes.PRODUCT_SUMMARY,
        next: OrderRoutes.ORDER_OPTIONS,
        back: (ctx, data) => data?.hasIncludedVoiceOffers
            ? OrderRoutes.ADDITIONAL_VOICE_OFFERS
            : OrderRoutes.VOICE_CONFIGURATION
    }
];
